module.exports = __webpack_public_path__ + "img/maingiffinal.72e6ebd1.webp";